
import { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../header';
import './Coaches.css';
import { Box, Grid, TextInput, Checkbox, Group , Button, PasswordInput, NumberInput, Input, NativeSelect} from '@mantine/core';
import { useForm } from '@mantine/form';
import { DataTable } from 'mantine-datatable';
import { IconSearch, IconCalendar, IconArrowRight,IconPlus,  IconTrash, IconPencil } from "@tabler/icons-react";
import moment from 'moment';
import { useNavigate, Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import userImage from '../../images/user.svg';
import { IMaskInput } from 'react-imask';

function Coaches() {

  localStorage.setItem("DATE", (moment()).format('YYYY-MM-DD'));

const [appData, setAppoData] = useState([]);
const [loaded, dataLoading] = useState(true);
const user = localStorage.getItem("user").replace(/['"]+/g, '');
const [error, setError] = useState(false);
const role =localStorage.getItem("userrole");
const userName = localStorage.getItem("userName");

const[assinngGroup, setAssingGroup] = useState('');
const [gorupsData, setGroupData] = useState([]);
const [groupLists, setGoupsList] = useState([]);
const[memberList, setMemberList] = useState([]);
const [coachesList, setCoachesList] = useState([]);
const [selectedCoachGp, setSelectedCoachGp] = useState([]);
const [filterdCoach, setFilteredChoach] = new useState([]);

const [num1, setNum] = useState();
const base_url = process.env.REACT_APP_BASE_URL;
function getData(){
  if(role !=='admin'){ navigate('/Login'); }
  axios({ method: "POST", url:base_url+"/admin/get-all-coach", crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
      setGroupData(response.data.response); 
      
      dataLoading(true);
      if(response.data.status===200){setFilteredChoach(response.data.response);  }else{
        setGroupData('No data')
      }
  })
}

function getMembers(){
  axios({ method: "POST", url:base_url+"/admin/add-new-group-list", crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
   // console.log(response.data.response)
    setMemberList(response.data.response); 
  })
}

function getPatients(){
  axios({ method: "GET", url:base_url+"/admin/user/get-all-users/1/1000", crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
    if(response.data.status === 200) {
      setPatientsList(response.data.response || []); 
    }
  }).catch((error) => {
    console.error('Error fetching patients:', error);
    setPatientsList([]);
  })
}

function getAssignedPatients(doctorEmail){
  if (!doctorEmail) return;
  setLoadingAssignedPatients(true);
  axios({ 
    method: "GET", 
    url: base_url + "/admin/get-patients-by-doctor", 
    params: { email: doctorEmail },
    crossDomain: true, 
    headers: {"Authorization" : `Bearer ${ user }`}
  }).then((response) => {
    if(response.data.status === 200) {
      setAssignedPatients(response.data.patients || []); 
    } else {
      setAssignedPatients([]);
    }
  }).catch((error) => {
    console.error('Error fetching assigned patients:', error);
    setAssignedPatients([]);
  }).finally(() => {
    setLoadingAssignedPatients(false);
  })
}

function getCoaches(e, i){
  setAssingGroup(e)
  setSelectedCoachGp(i)
  axios({ method: "POST", url:base_url+"/admin/get-all-groups", crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
    if(response.data.response !== "No data found"){
    setCoachesList(response.data.response); 
    }

  })
 
}


const formEdit = useForm({
  initialValues: {
    added_on: '',
    contact_number: '',
    email: '',
    first_name: '',
    group_of_user: [],
    last_name: '',
    password_of_user:''
  }
});

function getEditCoach(e){
  setEditCoachMail(e)
  axios({ method: "POST", url:base_url+"/admin/edit-all-show-list", data:{"email": e}, crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
    setGoupsList(response.data.response?.[0]); 
    formEdit.setValues({
      added_on: response.data.response[0].added_on,
      contact_number: response.data.response[0].contact_number,
      email: response.data.response[0].email,
      first_name: response.data.response[0].first_name,
      group_of_user: [],
      last_name: response.data.response[0].last_name,
      password_of_user:response.data.response[0].password_of_user,
    });
   // console.log(response.data.response)
  })
 // console.log(assinngGroup)
 
}

const form = useForm({
  initialValues: {
    first_name: '',
    last_name: '',
    email: '',
    contact_number: '',
    password_of_user: ''
  },
  validate: {
    first_name: (value) => (value.length < 2 ? 'Invalid First Name' : null),
    last_name: (value) => (value.length < 2 ? 'Invalid Last Name' : null),
    contact_number: (value) => (value.length < 9 ? 'Invalid Contact Number' : null),
    email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
    password_of_user: (value) => (value.length < 8 ? 'Password should be minimum 8 digit' : null),
    password_of_user_1: (value, values) => value !== values.password_of_user ? 'Passwords did not match' : null,
    
  },
});

const formAssign = useForm();

const formAssignPatient = useForm({
  initialValues: {
    patient_uuid: ''
  },
  validate: {
    patient_uuid: (value) => (!value ? 'Patient is required' : null),
  },
});



function handleSubmit(e) {

 // console.log(e)
  dataLoading(false)
  axios({ method: "POST", url:base_url+"/admin/add-coach", data: e, crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
   // console.log(response.data.response); 
    if(response.data.response==="User has been registered and email sent"){ dataLoading(true); setActive(false); form.reset()  }else{
      dataLoading(true); setError('Fail to add Coach!')
    }
  })
}

function handleDelete(e){
  dataLoading(false)
  axios({ method: "POST", url:base_url+"/admin/remove-coach", data: {"email": e}, crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
   // console.log(response.data.response); 
    if(response.data.response==="Coach removed successfully"){ dataLoading(true); setDelete(''); setSelectedUser('');  }else{
      dataLoading(true); setError('Fail to delete Coach!')
    }
  })
}

function handleAssign(e) {
  dataLoading(false)
const a = {
  "group_list":e.group_list,
  "email" :assinngGroup
}
  axios({ method: "POST", url:base_url+"/admin/assign-group-to-coach", data: a, crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
    //console.log(response.data.response); 
    if(response.data.response==="Assigned the group to coach successfully"){ dataLoading(true); setCoach(false); formAssign.reset(); }else{
      dataLoading(true); setError('Fail to assign Group!')
    }
  }) 
}

function handleAssignPatient(e) {
  if (!selectedDoctor) {
    setError('Doctor information is missing. Please try again.');
    return;
  }
  
  dataLoading(false);
  
  // Ensure phone number has country code
  let phoneNumber = selectedDoctor.phone || '';
  if (phoneNumber && !phoneNumber.startsWith('+')) {
    // If it's 10 digits, assume US number (+1)
    if (/^\d{10}$/.test(phoneNumber)) {
      phoneNumber = '+1' + phoneNumber;
    } else {
      // Otherwise, add + prefix
      phoneNumber = '+' + phoneNumber;
    }
  }
  
  const payload = {
    uuid: e.patient_uuid,
    email: selectedDoctor.email,
    phone: phoneNumber,
    name: selectedDoctor.name
  };
  
  console.log('[DEBUG handleAssignPatient] Payload:', payload);
  console.log('[DEBUG handleAssignPatient] URL:', base_url + "/admin/shared-patient-record");
  
  axios({ 
    method: "POST", 
    url: base_url + "/admin/shared-patient-record", 
    data: payload, 
    crossDomain: true, 
    headers: {
      "Content-Type": "application/json"
    }
  }).then((response) => {
    console.log('[DEBUG handleAssignPatient] Success response:', response.data);
    if(response.data.status === 200 && response.data.submitted === "Successfully"){
      dataLoading(true); 
      setError(false);
      setAssignSuccess(true);
      // Refresh assigned patients list
      if (selectedDoctor?.email) {
        getAssignedPatients(selectedDoctor.email);
      }
      // Close modal after 2 seconds
      setTimeout(() => {
        setAssignPatient(false); 
        formAssignPatient.reset();
        setSelectedDoctor(null);
        setAssignSuccess(false);
        setAssignedPatients([]);
      }, 2000);
    } else {
      dataLoading(true); 
      setError(response.data.response || 'Failed to assign doctor to patient!');
    }
  }).catch((error) => {
    console.error('[DEBUG handleAssignPatient] Error:', error);
    console.error('[DEBUG handleAssignPatient] Error response:', error.response?.data);
    console.error('[DEBUG handleAssignPatient] Error status:', error.response?.status);
    dataLoading(true);
    
    let errorMessage = 'Failed to assign doctor to patient!';
    if (error.response?.status === 500) {
      errorMessage = 'Server error (500). Please check backend logs. The request payload was correct.';
    } else if (error.response?.status === 400) {
      errorMessage = error.response?.data?.response || 'Invalid request. Please check all fields.';
    } else {
      errorMessage = error.response?.data?.response || error.response?.data?.message || error.message || errorMessage;
    }
    
    setError(errorMessage);
  });
}

function handleEdit(e) {
  dataLoading(false)
  let lc = (groupLists?.group_of_user)?.split(",").filter(n => n).length
  const obj = [];
 
 // console.log(lc)
  if(e.group_of_user.length === 0){
    (groupLists?.group_of_user)?.split(",").map(function(s) {
    //  console.log(s)
      obj.push(s)
    })
   }else if(e.group_of_user.length === lc){
    //console.log('s');
      obj.push()
   }else{
  ((groupLists?.group_of_user)?.split(",")).map(function(a) {
    if(e.group_of_user.length ){
    let matched = e.group_of_user.filter(b => a !== b);
    if (matched.length) { obj.push(a); } 
    }  
   })
  }
  
  
 const a = {
  "first_name":e.first_name,
  "last_name":e.last_name,
  "contact_number":e.contact_number,
  "email":e.email,
  "group_list":e.group_of_user,
  "group_of_user": String(obj)
}
//console.log(a)

   axios({ method: "POST", url:base_url+"/admin/edit-coach-list", data: a, crossDomain: true, headers: {"Authorization" : `Bearer ${ user }`},}).then((response) => {
    //console.log(response.data.response); 
    if(response.data.response==="Coach updated successfully"){ dataLoading(true); setEditCoach(false); formEdit.reset();  }else{
      dataLoading(true); setError('Your Changes have not been saved!')
    }
  })   
}

const [switchData, setSwithdata] = useState('userlist');
const [srch, search] = useState(false);


const navigate = useNavigate();
const logout = (e) => {
  /* let keysToRemove = ["user", "DATE", "userrole", "userName", "email"];
  keysToRemove.forEach(k =>
    localStorage.removeItem(k)) */
    localStorage.clear();
  navigate('/Login');
}

/* const logoutforadmin = (e) => {
  let keysToRemove = ["user", "DATE", "userrole", "userName", "email"];
  keysToRemove.forEach(k =>
    localStorage.removeItem(k))
  navigate('/Adminlogin');
} */

const [pagerVis, setPagerVis] = useState(true);

const [popopActive, setActive] = useState(false)
const [popopDelete, setDelete] = useState('')
const [assignCoach, setCoach] = useState(false)
const [userSelcted, setSelectedUser] = useState('')
const [editcoach, setEditCoach] = useState(false)
const [editCoachEmail, setEditCoachMail] = useState('')
const [searchActive, setSearchActive] = useState(false);
const [assignPatient, setAssignPatient] = useState(false);
const [selectedDoctor, setSelectedDoctor] = useState(null);
const [patientsList, setPatientsList] = useState([]);
const [assignSuccess, setAssignSuccess] = useState(false);
const [assignedPatients, setAssignedPatients] = useState([]);
const [loadingAssignedPatients, setLoadingAssignedPatients] = useState(false);
     useEffect(() => {
      if(searchActive===false){
      getData();
      }
      if(num1===null || num1==='' || num1==='undefined' || isNaN(num1)){
        setNum(1); 
        
      }
      if(popopActive===false && (popopDelete === null || popopDelete === '') && assignCoach===false && editcoach===false && assignPatient===false){
        setError();
      }
  }, [popopActive, popopDelete, assignCoach, editcoach, assignPatient]);


  function filterByCoach (event){
    const query = event.target.value;
    var updatedList = [...gorupsData];
    updatedList = gorupsData.filter((item) => {
      return (item?.first_name+' '+item?.last_name).toLowerCase().indexOf(query.toLowerCase()) !== -1 ;
    });
    setFilteredChoach(updatedList);
  };
  function blurSerach(e){
    // console.log(e.target.value)
     if(e.target.value === '' || e.target.value ===null){setSearchActive(false)}
   }


  return (
    
    <div className="Dashboard" >
      

     


      <div className="page-wrpper"> 
      <Header />
    <div className='content-wrapper' >
        <div className='header-area'>
         
          <div className='header-top'>
            <div className='left-content' >
            <h1>Doctors List </h1>
            </div>

            
            <div className='right-content'>
            { role ==='admin' ? <Link className='adminlogin' to={'/Adminlogin'} target="_blank">Database Admin</Link> : ''}
            <span className='current-user'><img alt="user" src={ userImage } />
           <span className='user-details'><span className='username'>{ userName }</span> <span className='userrole'>{ role }</span></span>
           
           <span className='user-popup'><button onClick={ logout }>Logout</button></span>
           </span>
            </div> 
          </div>
          
          {switchData === 'userlist' ?
          <>
          
          <div className='header-left'>

           <Grid align="center" mb="md">
            <Grid.Col xs={8} sm={9}>
              <TextInput sx={{ flexBasis: '60%' }} onFocus={()=> setSearchActive(true)} onBlur={(value)=> blurSerach(value)} onChange={(value)=>filterByCoach(value)} placeholder="Search Coach by Name" icon={<IconSearch size={16} />}    />
            </Grid.Col></Grid>
        </div>

        <div className='header-right'>
        <div className='filter item' >
            <div className="filter-title" onClick={()=> (setActive(true), getMembers())}> + Add Doctor </div>
        </div> 

      </div>
      
      </> : ''}
      </div>


      <div className='main-content groups-data'>
      
      
      {gorupsData === 'No data' ? '' : (

      <Box >
    {<DataTable
      noHeader
      records={filterdCoach}
      columns={[
        {cellsClassName: 'first-name', accessor: 'first_name', width: 100},
        {cellsClassName: 'last-name', accessor: 'last_name', width: 100},
        {cellsClassName: 'contact-number', accessor: 'contact_number', width: 150},
        {cellsClassName: 'email', width: 250, accessor: 'email'},
        {accessor: 'added_on', render:({added_on}) => (moment(added_on).format('DD MMM YYYY')), cellsClassName:'added-on', width: 150},
        {cellsClassName: 'groups', width: 200, accessor: 'group_of_user'},
        {accessor: 'members', cellsClassName:'ctas', width: 350,  render: ({ first_name, last_name, email, contact_number, group_of_user}) => (
            <div className='cta-wrapper'>
              <span onClick={() => {
                // Format phone number - ensure it has country code
                let formattedPhone = contact_number || '';
                if (formattedPhone && !formattedPhone.startsWith('+')) {
                  // If it's 10 digits, assume US number (+1)
                  if (/^\d{10}$/.test(formattedPhone)) {
                    formattedPhone = '+1' + formattedPhone;
                  } else {
                    // Otherwise, add + prefix
                    formattedPhone = '+' + formattedPhone;
                  }
                }
                
                setSelectedDoctor({ name: `${first_name} ${last_name}`, email, phone: formattedPhone });
                formAssignPatient.setValues({
                  patient_uuid: ''
                });
                setAssignPatient(true);
                getPatients();
                getAssignedPatients(email);
              }} className='assign-cta'> <IconPlus></IconPlus> Assign to Patient</span>
              <span onClick={() => ( setCoach(true), getCoaches(email, group_of_user))} className='assign-cta'> <IconPlus></IconPlus> Assign Group</span>
              <span onClick={() => ( setEditCoach(true), getEditCoach(email))} className='edit-cta'> <IconPencil></IconPencil> Edit </span>
              <span onClick={() => (setDelete(email), setSelectedUser(first_name+" "+last_name)) } className='delete-cta'><IconTrash></IconTrash> Delete</span>
            </div> 
            )}
      ]}

    />}

{ pagerVis === true  ? ( <>
<div className="mantine-ooem79 pager">
  <div className="mantine-Group-root mantine-kn8vaf">
    {/* <button className="mantine-UnstyledButton-root mantine-Pagination-control mantine-4clav0" onClick={()=> { pager(-1) }} data-disbaled={num1===1 ? 'disabled' : 'visible'}  type="button" ><svg width="calc(1.625rem / 2)" height="calc(1.625rem / 2)" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" className="mantine-2jxpqh"><path d="M7.219 8l3.3 3.3-.943.943L5.333 8l4.243-4.243.943.943-3.3 3.3z" fill="currentColor"></path></svg></button>
    <button className="mantine-UnstyledButton-root mantine-Pagination-control mantine-ua81gg" onClick={()=> {pager(-1)}} data-hidden={num1===1 ? 'disabled' : 'visible'} type="button" >{num1-1}</button>
    <button className="mantine-UnstyledButton-root mantine-Pagination-control mantine-ua81gg active" type="button" >{num1}</button>
    <button className="mantine-UnstyledButton-root mantine-Pagination-control mantine-ua81gg" onClick={()=> {pager(1)}} data-hidden={num1===a ? 'disabled' : 'visible'}  type="button" >{num1+1}</button>
    <button className="mantine-UnstyledButton-root mantine-Pagination-control mantine-4clav0" onClick={()=> {pager(1) }} data-disbaled={num1===a ? 'disabled' : 'visible'} type="button" ><svg width="calc(1.625rem / 2)" height="calc(1.625rem / 2)" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" className="mantine-2jxpqh"><path d="M8.781 8l-3.3-3.3.943-.943L10.667 8l-4.243 4.243-.943-.943 3.3-3.3z" fill="currentColor"></path></svg></button>
 */}    </div>
    </div>
</>) :''}
</Box>
  )}

  
{loaded === false ? <div className='global-loader'><Loader /></div> : '' }

{ popopActive === true ? (
  <>
  <div className='poup-bg'></div>
<div className='popup add-group assign-group add-coach'>
  <span className='close' onClick={()=> setActive(false)}></span>
  <div className='popup-titlebar'>
      <h2>Add New Doctor</h2>
  </div>
  {error ? <div className='error-msg'>{error}</div> : ''}
  <form onSubmit={form.onSubmit((values) => ( handleSubmit(values)  ))}>
        <TextInput withAsterisk label="" required placeholder="First Name" {...form.getInputProps('first_name')}/>
        <TextInput withAsterisk label="" required placeholder="Last Name" {...form.getInputProps('last_name')} />
        <TextInput withAsterisk label="" required placeholder="email" {...form.getInputProps('email')} />
        <TextInput component={IMaskInput} mask="0000000000" required placeholder="Contact Number" {...form.getInputProps('contact_number')} />
        <PasswordInput withAsterisk label="" required placeholder="Password" {...form.getInputProps('password_of_user')} />
        <PasswordInput withAsterisk label="" required placeholder="Confirm Password" {...form.getInputProps('password_of_user_1')} />
        <Group justify="flex-end" mt="md">
          <Button type="submit">Submit</Button>
        </Group>
      </form>


</div>
</>
):''}

{ popopDelete !== null && popopDelete !== '' ? (
  <>
  <div className='poup-bg'></div>
<div className='popup add-group delete-group'>
  <span className='close' onClick={()=> setDelete('')}></span>
  <div className='popup-titlebar'>
      <h2>Delete</h2>
  </div>
  {error ? <div className='error-msg'>{error}</div> : ''}
    <div className='popup-content'>
      <p>Are you sure you want to Remove Doctor { userSelcted }</p>
      <p>Once you Remove Doctor { userSelcted }, all the data will be erased permanently.</p>
    </div>

        <Group justify="flex-end" mt="md">
          <Button className='cancel-cta' onClick={()=> setDelete('')}>Cancel</Button>
          <Button  onClick={()=> handleDelete(popopDelete)}>Yes</Button>
        </Group>
 


</div>
</>
):''}

{ assignCoach === true ? (
  <>
  <div className='poup-bg'></div>
<div className='popup add-group assign-coach'>
  <span className='close' onClick={()=> setCoach(false)}></span>
  <div className='popup-titlebar'>
      <h2>Groups</h2>
  </div>
  {error ? <div className='error-msg'>{error}</div> : ''}
  <form onSubmit={formAssign.onSubmit((values) => (handleAssign(values) ))}>
        
<Checkbox.Group 
      label=""
      description="" 
      withAsterisk {...formAssign.getInputProps('group_list')}
    >
      <Group>
        { coachesList?.map((i, index)=> (
           <>{selectedCoachGp?.includes(i) ?'' : <Checkbox key={index} value={i} label={i} /> }</>)
        )}
        
      </Group>
      
    </Checkbox.Group>


{ selectedCoachGp?.split(",").filter(n => n).length !== coachesList?.length ? <>
        <Group justify="flex-end" mt="md">
          <Button type="submit">Assign Group</Button>
        </Group>
        </> : <>
        <p style={{ 'textAlign' : 'center' }}> This Doctor assigned all Groups or no Group is available! </p>
        <Group justify="flex-end" mt="md">
          <Button disabled type="submit">Assign Group</Button>
        </Group>
        </>}
      </form>


</div>
</>
):''}

{ editcoach === true ? (
  <>
  <div className='poup-bg'></div>
<div className='popup add-group edit edit-coach'>
  <span className='close' onClick={()=> (setEditCoach(false), formEdit.reset())}></span>
  <div className='popup-titlebar'>
      <h2>Edit</h2>
  </div>
  {error ? <div className='error-msg'>{error}</div> : ''}
  <form onSubmit={formEdit.onSubmit((values) => (handleEdit(values) ))}>     
        <TextInput  label="First Name" required placeholder="First Name" {...formEdit.getInputProps('first_name')}/>
        <TextInput  label="Last Name" required placeholder="Last Name" {...formEdit.getInputProps('last_name')} />
        <TextInput  label="Email" disabled placeholder="email" {...formEdit.getInputProps('email')} />
        <TextInput  label="Contact Number" required placeholder="Contact Number" {...formEdit.getInputProps('contact_number')} />

        <Checkbox.Group className='members-list'
      label="Groups"
      description="" 
       {...formEdit.getInputProps('group_of_user')} >
      <Group>
        
        {groupLists?.group_of_user ? ((groupLists?.group_of_user).split(",")).map((i, index)=> 
           <Checkbox key={index} value={i} label={i} />
        ) : ''}
      </Group>
    </Checkbox.Group>


        <Group justify="flex-end" mt="md">
          <Button type="submit">Save</Button>
        </Group>
      </form>


</div>
</>
):''}

{ assignPatient === true ? (
  <>
  <div className='poup-bg'></div>
<div className='popup add-group assign-patient'>
  <span className='close' onClick={()=> (setAssignPatient(false), formAssignPatient.reset(), setSelectedDoctor(null), setAssignSuccess(false), setAssignedPatients([]))}></span>
  <div className='popup-titlebar'>
      <h2>Assign Doctor to Patient</h2>
  </div>
  {error ? <div className='error-msg'>{error}</div> : ''}
  {assignSuccess ? (
    <div className='success-msg' style={{ background: '#4CAF50', color: '#fff', padding: '15px', borderRadius: '8px', marginBottom: '15px', textAlign: 'center' }}>
      ✓ Doctor successfully assigned to patient!
    </div>
  ) : ''}
  <form onSubmit={formAssignPatient.onSubmit((values) => (handleAssignPatient(values) ))}>
        <NativeSelect
          label="Select Patient"
          required
          placeholder="Select a patient"
          data={patientsList.map(patient => ({
            value: patient.uuid,
            label: `${patient.firstname || ''} ${patient.lastname || ''} (${patient.email || ''})`
          }))}
          {...formAssignPatient.getInputProps('patient_uuid')}
          mb="sm"
          disabled={assignSuccess}
        />
        
        <Group justify="flex-end" mt="xs">
          <Button type="submit" disabled={assignSuccess}>Assign Doctor</Button>
        </Group>
      </form>

      {!assignSuccess && (
        <div style={{ marginTop: '20px', borderTop: '1px solid rgba(145, 158, 171, 0.32)', paddingTop: '15px' }}>
          <h3 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '10px', color: '#212B36' }}>
            Assigned Patients ({assignedPatients.length})
          </h3>
          {loadingAssignedPatients ? (
            <div style={{ textAlign: 'center', padding: '10px', color: '#919EAB' }}>Loading...</div>
          ) : assignedPatients.length > 0 ? (
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {assignedPatients.map((patient, index) => (
                <div 
                  key={index} 
                  style={{ 
                    padding: '8px 12px', 
                    marginBottom: '8px', 
                    background: '#f5f5f5', 
                    borderRadius: '6px',
                    fontSize: '13px'
                  }}
                >
                  <div style={{ fontWeight: 500, color: '#212B36' }}>
                    {patient.firstname || ''} {patient.lastname || ''}
                  </div>
                  <div style={{ fontSize: '12px', color: '#919EAB', marginTop: '2px' }}>
                    {patient.patient_email || ''}
                  </div>
                  {patient.first_shared_at && (
                    <div style={{ fontSize: '11px', color: '#919EAB', marginTop: '2px' }}>
                      Assigned: {moment(patient.first_shared_at).format('DD MMM YYYY')}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '10px', color: '#919EAB', fontSize: '13px' }}>
              No patients assigned yet
            </div>
          )}
        </div>
      )}

</div>
</>
):''}


</div>

    </div>

</div>

</div>

    
  );

}





export default Coaches;
